import React from 'react';
import { makeStyles } from '@material-ui/core';

import { AppBar, Divider, Toolbar } from '@ha/dsl';

const useStyles = makeStyles(() => ({
  // to not affect navbar height since it's used as a constant in multiple places
  divider: {
    marginTop: '-1px',
  },
}));

export const AppBarMobile: React.FC = ({ children }) => {
  const classes = useStyles();

  return (
    <AppBar
      elevation={0}
      position="static"
      color="inherit"
      data-test-locator="NavBar Top Mobile"
    >
      <Toolbar>{children}</Toolbar>
      <Divider className={classes.divider} />
    </AppBar>
  );
};

export default AppBarMobile;
